export class Player {
  constructor(type) {
    this.type = type;
    this.score = 0;
  }
}
